import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { HEADER_HEIGHT } from '@/config/constants';
import { AdminHeader } from './AdminHeader';

export const AdminLayout = () => {
  return (
    <Box
      className="taste-page-chrome"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <AdminHeader />
      <Container
        className="taste-rise"
        sx={{
          minHeight: '70vh',
          mt: `${HEADER_HEIGHT}px`,
          py: '40px',
          // let wide tables scroll inside their own container, not the page
          minWidth: 0,
        }}
      >
        <Outlet />
      </Container>
    </Box>
  );
};
